<template>
  <div class="page-title">
    <h1
      v-if="home"
      class="link-content"
    >
      <router-link :to="home">
        {{ main }}
      </router-link>
    </h1>
    <h2>
      <v-icon
        large
        color="blue darken-2"
        v-if="icon"
      >
        {{ icon }}
      </v-icon>
      {{ sub }}
    </h2>
    <hr class="mb-4">
  </div>
</template>

<script>
export default {
  name: 'PageTitle',
  props: {
    icon: {
      type: String
    },
    main: {
      type: String
    },
    sub: {
      type: String
    },
    home: {
      type: String,
      default: null
    }
  }
}
</script>

<style>
.page-title h1 {
  margin: 0px;
}

.page-title h2 {
  color: #777;
  margin-top: 5px;
  font-size: 1.3rem;
}
.link-content {
  color: #0c3b52;
  opacity: 0.7;
  transition: visibility 0s, opacity 0.5s linear;
}

.link-content:hover {
  visibility: visible;
  opacity: 1;
}

.link-content a {
  text-decoration: none;
  color: #000;
  padding: 10px;
}
</style>
